<template>
  <v-container fluid>
    <div id="app ">
      <!-- <v-row
        style="display: flex; justify-content: space-between; width: 100%;"
      > -->
      <div style="display: flex; justify-content: space-between;">
        <Breadcrumb class="row justify-content-center mt-4" />
        <!-- </div> -->
        <span v-if="showLoader">
          <LoaderProgress></LoaderProgress>
        </span>
      </div>
    </div>
    <v-row class="mt-0 border-bottom">
      <v-col>
        <newcompoent
          style="margin-right: 5px !important; "
          :filter_data="param"
        />
      </v-col>
    </v-row>
    <v-row>
      <div
        v-if="showresult"
        style="margin-left:2%; font-weight:bold; font-size:20px; color:#0c479d"
      >
        Live Result
        <v-chip class="ma-2" color="#0c479d" label outlined>
          {{ results }}
        </v-chip>
      </div>
      <div
        v-if="showresult"
        style="margin-left:2%; font-weight:bold; font-size:20px; color:#0c479d"
      >
        Oil Name
        <v-chip class="ma-2" color="#0c479d" label outlined>
          {{ oil_name }}
        </v-chip>
      </div>
    </v-row>
    <v-row>
      <!-- height="200px"
 width=475px -->
      <!-- <v-row style="margin: 50px 0"> -->
      <!-- <div style="display: flex; flex-wrap: wrap;"> -->
      <!-- <div v-bind:key="val.id" v-for="val in insightsData"> -->
      <template v-if="showInsights">
        <v-col
          v-for="val in insightsData"
          :key="val.id"
          cols="12"
          sm="12"
          md="6"
          lg="6"
          style="display: flex;   align-items: center; justify-content: center; "
        >
          <v-card
            class="oee-card oee-card-white card-shadow "
            height="100%"
            max-height="300px"
            width="100%"
            style="overflow-y: auto; "
          >
            <v-card-text>
              <v-row align="center">
                <v-icon color="primary">icon-insights</v-icon>
                <v-card-title class="pt-0 pb-0"> Machine Insights</v-card-title>
              </v-row>
              <v-row>
                <div v-bind:key="epa.id" v-for="epa in val.insights">
                  <pre>
-----------------------------------------------
                      </pre
                  >
                  <!-- <span> -->
                  <p>
                    <span v-if="'insight_type' in epa" class="insights_param">
                      {{ epa.parameter_name }}
                    </span>
                    <span
                      v-if="'insight_type' in epa || 'insight_type' in epa"
                      v-bind:class="{
                        insights_normal:
                          epa.insight_type == '0' ||
                          epa.insight_type == 'normal',
                        insights_alert: epa.insight_type == 'alert',
                        insights_caution: epa.insight_type == 'caution',
                      }"
                      v-html="epa.insight_statement"
                    >
                      {{ epa.insight_statement }}
                    </span>
                  </p>
                  <!-- </span> -->
                </div>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </template>
      <!-- </div> -->
      <template v-if="showInsights">
        <v-col
          :key="epak.id"
          v-for="epak in alertsData"
          cols="12"
          sm="12"
          md="6"
          lg="6"
          style="display: flex;   align-items: center; justify-content: center; "
        >
          <v-card
            class=" oee-card oee-card-white card-shadow "
            width="100%"
            height="100%"
            max-height="400px"
          >
            <v-card-text align="center">
              <v-row align="center">
                <v-icon color="primary" class="pt-3 pl-3 pb-3"
                  >icon-insights</v-icon
                >
                <v-card-title class=" pt-3 pl-3 pb-3">
                  Violation Trends</v-card-title
                >
              </v-row>
              <v-row align="center">
                <v-col>
                  <barChart :epak="vueChartData" v-if="vueChartshow" />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </template>

      <template>
        <!-- <v-row> -->
        <v-col
          :key="apq.chartOptions"
          v-for="apq in new_data_chart"
          cols="12"
          sm="12"
          md="6"
          lg="6"
          style="display: flex;   align-items: center; justify-content: center; "
        >
          <!-- <v-container> -->
          <v-card
            class="oee-card oee-card-white card-shadow "
            width="100%"
            height="100%"
          >
            <v-row align="center" class="mb-2 ">
              <v-icon color="primary" class="pt-3 pl-3 pb-3">{{
                Changeiconaspertitle(apq.chartTitle)
              }}</v-icon>
              <v-card-title class=" pt-3 pl-3 pb-3">{{
                apq.chartTitle
              }}</v-card-title>
            </v-row>
            <v-row align="center" class="text-center mbN-4">
              <v-col class="pr-4 pl-3 pa-1 pb-3">
                <div>
                  <lineChart v-bind:apq="apq" />
                </div>
              </v-col>
            </v-row>
          </v-card>
          <!-- </v-container> -->
        </v-col>
        <!-- </v-row> -->
      </template>

      <template>
        <v-col
          cols="12"
          sm="12"
          md="6"
          lg="6"
          style="display: flex;   align-items: center; justify-content: center; width:100%"
        >
          <v-card
            v-if="this.showGauge"
            class="oee-card oee-card-white card-shadow "
            width="100%"
            height="100%"
          >
            <!-- <v-card-title class=" pt-3 pl-3 pb-3">
              Machine Up Time
            </v-card-title> -->
            <v-row align="center" class="text-center mbN-4">
              <v-col class="pr-4 pl-3 pa-1 pb-3">
                <div>
                  <guage
                    v-bind:gag="guageData"
                    v-if="this.showGauge"
                    style="height: 100%;"
                  />
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import guage from "../components/oilqualitygauge.vue";
import axios from "axios";
import newcompoent from "../components/newFiltercomp.vue";
import router from "../router";
import Breadcrumb from "../components/breadcrumbs.vue";
import LoaderProgress from "../components/progressLoader";
var prevNowPlaying = null;
import barChart from "../components/barChart.vue";
import lineChart from "../components/lineChart.vue";
import jwt_decode from "jwt-decode";

export default {
  prop: ["apqData", "guageData"],
  components: {
    barChart,
    lineChart,
    newcompoent,
    guage,
    Breadcrumb,
    LoaderProgress,
  },
  data: () => ({
    new_data_chart: [],
    my_data: [],
    seriesDataLineChartShow: false,
    //changes
    // showLinechart:false,
    vueChartData: null,
    vueChartshow: false,
    param: {
      machine: true,
      time_period: false,
      check: false,
      aggfunc: true,
      date: false,
      date_2: false,
      time: false,
      time2: false,
      select_1: 360,
    },

    show_oil: false,
    showresult: false,
    showLoader: false,
    alertsData: [],
    oil_name: "",
    insightsData: [],
    apqData: [],
    apqData_i: [],
    machine_id_Selected: "",
    start_date: "",
    end_date: "",
    param_grps: [],
    showInsights: false,
    results: "",
    showGauge: false,
    guageData: [],
    checkbox: false,
    oilInterval: "",
    widgets_obj_map: new Map(),
    alert_caution_map: new Map(),
    parameter_group_obj: [],
    minlist: [],
    maxlist: [],
    latestTimeStampsOfAllPlots: [],

    fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    menu1: false,
    menu2: false,
    selectedDate: "Today",
    machinelist: ["DPIMM01", "DPIMM02", "DPIMM03", "DPIMM04", "DPIMM05"],
    dates: [],
    parameters: [],
    DeviceParameterData: {},
    device_id: null,
    websocketconnection: null,
    customer_id: null,
  }),
  beforeDestroy() {
    console.log("beforeDestroy oil cleaning page");
    clearInterval(prevNowPlaying);
    this.closeWebSocketConnection();
    this.checkbox = false;
  },
  mounted() {
    //  this.methodCall()
    this.customer_id = jwt_decode(
      sessionStorage.getItem("token")
    ).organization_id;
  },

  methods: {
    OpenWebSocketConnection() {
      try {
        console.log(
          "inside web scoket live data connection",
          this.customer_id,
          this.machine_id_Selected,
          this.device_id
        );
        this.websocketconnection = new WebSocket(
          `${this.$config.websocket_url}`
        );
      } catch (error) {
        console.log(error);
      }
      this.websocketconnection.onopen = (event) => {
        console.log(event);
        this.websocketconnection.send(
          `${this.customer_id}-${this.machine_id_Selected}-${this.device_id}`
        );
      };
      try {
        this.websocketconnection.onmessage = (event) => {
          console.log("data received from socket--->>>");
          let message = JSON.parse(event.data);
          this.setLiveChartData(message);
        };
      } catch (error) {
        console.log(error);
        this.closeWebSocketConnection();
      }
    },
    closeWebSocketConnection() {
      if (this.websocketconnection != null) {
        this.websocketconnection.close();
        console.log("websocket connection is closed...");
      } else {
        console.log("previousy connection was not established");
      }
    },
    setLiveChartData(message) {
      console.log("chart data", this.new_data_chart);
      for (let index = 0; index < this.new_data_chart.length; index++) {
        console.log(
          "before update length",
          this.new_data_chart[index].timestampsLt.length,
          index
        );
        this.new_data_chart[index].timestampsLt.splice(0, 1);
        this.new_data_chart[index].timestampsLt.push(message.unix_ts);
        console.log(
          "after update length",
          this.new_data_chart[index].timestampsLt.length
        );
        for (
          let index1 = 0;
          index1 < this.new_data_chart[index].seriesvalues.length;
          index1++
        ) {
          let param_id = this.DeviceParameterData[
            this.new_data_chart[index].seriesvalues[index1].name
          ];
          let value = message.analysis[param_id];
          console.log(
            "parameter_id-->>",
            param_id,
            "paramter value-->>",
            value,
            "timestamp-->>",
            message.unix_ts
          );
          this.new_data_chart[index].seriesvalues[index1].data.splice(0, 1);
          this.new_data_chart[index].seriesvalues[index1].data.push(value);
        }
      }
      console.log(
        "latestmessage",
        this.new_data_chart,
        this.DeviceParameterData,
        message
      );
    },
    SocketConnectionCondition(
      old_machine_id,
      new_machine_id,
      startDate,
      endDate,
      check
    ) {
      console.log("check inside connection", check);
      if (
        old_machine_id != new_machine_id &&
        new_machine_id != null &&
        this.websocketconnection != null
      ) {
        console.log("socketdisconnected");
        this.closeWebSocketConnection();
      }
      console.log("checkiing check ", check);
      if (check == true) {
        this.OpenWebSocketConnection();
      } else {
        this.closeWebSocketConnection();
      }
    },
    // methodCall(){
    //   setInterval(function () {
    //     this.count= Math.random();
    //     console.log(this.count)
    //   }, 1000);
    // },
    assignparam(event) {
      // let machineID = event;
      if (event !== null) {
        let config = {
          method: "get",
          url: `${this.$config.backend_url}/getParametersData?machine_id=${event}`,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        };
        this.noteLastAPICallTime();
        axios(config)
          .then((response) => {
            // console.log("response--parameter names", response.data.data);
            this.parameters = [];
            let parametersList = response.data.data;
            console.log("parametersListparametersList", parametersList);
            // parametersList.sort((first_operator, second_operator) => {
            //   return this.compareObjects(
            //     first_operator,
            //     second_operator,
            //     "parameter_name"
            //   );
            // });
            this.parameters = parametersList;
          })
          .catch((error) => {
            this.showLoader = false;
            if (error.response && error.response.status === 401) {
              sessionStorage.clear();
              router.push("/login");
            } else {
              alert("internal error");
              console.log("axios error", error.message);
            }
          });
      }
    },
    Changeiconaspertitle(value) {
      // console.log("checking value", value);
      if (value == "ISO Rating") return "mdi-seal";
      else if (value == "RH Data") return "icon-bolt";
      else if (value == "NAS") return "icon-bolt";
    },
    timeConverter: (UNIX_timestamp) => {
      // let a = new Date(UNIX_timestamp * 1000);
      console.log(" in time converter ", UNIX_timestamp);
      let a = new Date(UNIX_timestamp - 19800);
      console.log(" in time converter a ", a);
      let months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let year = a.getFullYear();
      let month = months[a.getMonth()];
      let date = a.getDate();
      let hour = a.getHours();
      let min = a.getMinutes();
      let sec = a.getSeconds();
      let time =
        date + " " + month + " " + year + " " + hour + ":" + min + ":" + sec;
      console.log(" in time converter time ", time);
      return time;
    },
    getData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      old_machine_id,
      check
    ) {
      this.latestTimeStampsOfAllPlots.clear;
      let params = `?machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getIPDMonitoringData${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      axios(config).then((response) => {
        try {
          console.log("actual data is ", response);
          // if (Object.keys(response.data.data[0].analysis).length===0){
          // this.seriesDataLineChartShow = false
          // }
          this.showLoader = true;

          let theResultKeys = [];
          let data_series = [];
          for (
            let param_grp_index = 0;
            param_grp_index < this.parameter_group_obj.length;
            param_grp_index++
          ) {
            if (
              this.parameter_group_obj[param_grp_index]["group"] == "ISO Rating"
            ) {
              let each_param_group_list = this.parameter_group_obj[
                param_grp_index
              ]["parameter_list"];
              each_param_group_list.forEach((param) => {
                //  console.log("sudheer reddy hello 3", param);
                theResultKeys.push(param.id);
              });
            }
          }
          // response.data.data[0].parameter_group.forEach((data) => {
          //   // console.log("sudheer reddy hello", data.group);
          //   if (data.group === "ISO Rating") {
          //      console.log("sudheer reddy hello 2", data.group);
          //     data.parameter_list.forEach((param) => {
          //        console.log("sudheer reddy hello 3", param);
          //       theResultKeys.push(param.id);
          //     });
          //   }
          // });
          console.log("checking resultkeys", theResultKeys);
          theResultKeys = theResultKeys.sort();

          // let theResults = [];
          // theResultKeys.forEach((key) => {
          //   let theData = response.data.data[0].data[0].data[key];
          //   theResults.push(theData[theData.length - 1].reading);
          // });
          let theString = "";
          theResultKeys.forEach((key, index) => {
            response.data.data[0].data.forEach((data) => {
              if (key == data.parameter_name) {
                if (index < theResultKeys.length - 1) {
                  theString = theString + `≥	${data.value.toFixed()}/ `;
                } else {
                  theString = theString + `≥${data.value.toFixed()} `;
                }
              }
              this.latestTimeStampsOfAllPlots.push(data.unix_ts);
              console.log("machine time is ", this.latestTimeStampsOfAllPlots);
            });
            console.log(
              "this.latestTimeStampsOfAllPlots ",
              Math.max(...this.latestTimeStampsOfAllPlots)
            );
            this.guageData["timestamp"] = this.timeConverter(
              Math.max(...this.latestTimeStampsOfAllPlots)
            );
          });

          // theResults.forEach((num, index) => {
          //   if (index < theResults.length - 1) {
          //     theString = theString + '≥	${num.toFixed()}/ ';
          //   } else {
          //     theString = theString + '≥${num.toFixed()} ';
          //   }
          // });
          this.results = theString;
          if (this.results != "") {
            this.showresult = true;
          }

          let actualData = response.data.data[0].analysis || {};
          console.log("Object.keys(actualData).length", actualData.unix_ts);

          //change

          for (let i = 0; i < this.new_data_chart.length; i++) {
            this.new_data_chart[i].timestampsLt = actualData.unix_ts;
          }

          //chnage

          console.log("this", this.apqData);
          for (let i = 0; i < this.apqData.length; i++) {
            let eachChartObj = this.apqData[i];
            if (Object.keys(actualData).length > 0) {
              eachChartObj.chartOptions = {
                ...eachChartObj.chartOptions,
                ...{
                  xaxis: {
                    categories: actualData["unix_ts"],
                  },
                },
              };
            }

            let seriesvalues = [];
            for (
              let param_grp_index = 0;
              param_grp_index < this.parameter_group_obj.length;
              param_grp_index++
            ) {
              if (
                this.parameter_group_obj[param_grp_index]["group"] ==
                eachChartObj.id
              ) {
                let each_param_group_list = this.parameter_group_obj[
                  param_grp_index
                ]["parameter_list"];
                for (
                  let param_name = 0;
                  param_name < each_param_group_list.length;
                  param_name++
                ) {
                  {
                    let singlValue = {
                      name: each_param_group_list[param_name]["actual_name"],
                      data: actualData[each_param_group_list[param_name]["id"]],
                    };
                    seriesvalues.push(singlValue);
                    console.log(
                      "assigning values for id ",
                      each_param_group_list[param_name]["id"]
                    );
                  }
                }
              }
            }

            //chnages
            console.log(
              "checking value seriesvaluesseriesvalues",
              this.new_data_chart
            );

            data_series.push(seriesvalues);

            let alert_caution_list = this.alert_caution_map.get(
              eachChartObj.id
            );
            for (
              let seriesListindex = 0;
              seriesListindex < alert_caution_list.length;
              seriesListindex++
            ) {
              let each_list = alert_caution_list[seriesListindex];
              for (let index = 0; index < each_list.length; index++) {
                let obj = each_list[index];
                obj.data = [];
                seriesvalues.push(obj);
              }
            }
            eachChartObj.series = seriesvalues;
          }
          this.showLoader = false;
          //on this true it will show line chart
          console.log("this.apqDatathis.apqData -->", this.new_data_chart);
          // this.showLinechart = true;
          //change

          // if (this.new_data_chart.length==6){
          //    let a =  this.new_data_chart.splice(0, 3);
          //    console.log("bhsvbsbhvsb",a)
          //   }

          console.log("data chewcvbjbjc", this.new_data_chart);

          for (let i = 0; i < this.new_data_chart.length; i++) {
            this.new_data_chart[i].seriesvalues = data_series[i];
          }
          if (this.new_data_chart[0].timestampsLt === undefined) {
            this.seriesDataLineChartShow = false;
          } else {
            this.seriesDataLineChartShow = true;
          }
          //change
          console.log("this.new_chart data check", this.new_data_chart);
          try {
            this.SocketConnectionCondition(
              old_machine_id,
              this.machine_id_Selected,
              startDate,
              endDate,
              check
            );
          } catch (error) {
            console.log(error);
          }
        } catch (exception) {
          this.new_data_chart = [];
          this.apqData = [];
          this.guageSet = [];
          this.present = true;
          this.showLoader = false;
          console.log("error", exception);
        }
      });
    },
    searchNew: function(
      machine_id,
      old_machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      // this.new_data_chart = []
      this.seriesDataLineChartShow = false;
      this.start_date = startDate;
      this.end_date = endDate;
      // document.querySelector("#warningAlert").style.display = "none";
      this.machine_id_Selected = machine_id;
      let params = "";
      // document.querySelector("#loaderStyle").style.display = "block";
      this.showLoader = true;
      console.log("checking achine", machine_id);

      if (this.start_date == "") {
        params = `?machine=${machine_id}`;
      } else {
        params = `?&machine=${machine_id}&startdate=${this.start_date}&enddate=${this.end_date}&agg_function=${show}&timeframe=${grp_show}`;
      }
      let config = {
        method: "get",
        url: `${this.$config.backend_url}/getIPDMonitoringSetup${params}`,
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`,
        },
      };
      this.noteLastAPICallTime();
      axios(config)
        .then((response) => {
          this.new_data_chart = [];

          if (response.data.data != []) {
            this.showInsights = false;
            this.showGauge = false;
          }
          try {
            this.widgets_obj_map.clear();
            let condemn_list =
              response.data.data[0].condemning_limit_list || [];
            let alerts_stack_data = response.data.data[0].alerts_data || [];
            let oil_name_m = response.data.data[0].oil_name || "Mobil";
            let avg_date_str = response.data.data[0].avg_date_str;
            let avg_alerts_empty = response.data.data[0].avg_alerts_empty;

            // console.log("checking oil name",oil_name_m);

            this.oil_name = oil_name_m || "Mobil";
            if (this.oil_name != "") {
              this.show_oil = true;
            }
            // console.log("Checking alerts stack data",alerts_stack_data);
            let dates = alerts_stack_data[1] || [];
            let stack_dic = alerts_stack_data[0] || [];
            let params_list = alerts_stack_data[2] || [];
            console.log("checking dates and stack data", dates, stack_dic);
            let parameter_value_all_month = [];
            let total_params = [];
            // this.alertsData = [];
            for (let k = 0; k < params_list.length; k++) {
              console.log(
                "Checking parameter ids",
                params_list[k],
                stack_dic,
                stack_dic.length
              );

              for (let j = 0; j < stack_dic.length; j++) {
                for (let i = 0; i < dates.length; i++) {
                  {
                    if (
                      dates[i] == stack_dic[j]["date"] &&
                      stack_dic[j]["parameter_id"] == params_list[k]
                    ) {
                      parameter_value_all_month.push(stack_dic[j]["count"]);
                    }
                  }
                }
              }
              let param_name = "";
              for (let i = 0; i < this.parameters.length; i++) {
                if (this.parameters[i]["parameter_id"] === params_list[k]) {
                  param_name = this.parameters[i]["parameter_name"];
                  console.log(
                    "Checking after coniditon statisfied",
                    param_name
                  );
                }
              }
              console.log("Checking out of condition", param_name);
              let dicData = {
                name: param_name,
                data: parameter_value_all_month,
              };
              total_params.push(dicData);
              parameter_value_all_month = [];
            }

            if (avg_alerts_empty == true) {
              for (let i = 0; i < total_params.length; i++) {
                total_params[i]["data"].unshift(0);
              }
              dates.unshift(avg_date_str);
            } else {
              dates[0] = avg_date_str;
            }

            let chartData = {};

            //data and property send to vueChart.vue component to plot the bar chart
            this.vueChartData = {
              total_params: total_params,
              dates: dates,
              type: "bar",
              height: "200px",
              width: "476px",
              title_text: "Violation Count",
              position: "top",
              horizontalAlign: "center",
              marginLeft: "-10px",
              xaxisTitle: {
                text: "Time",
                align: "right",
                offsetY: -10,

                style: {
                  color: "#484848",
                  fontSize: "14px",
                  fontWeight: "bold",
                },
              },
              xaxisBorder: {
                show: true,
                color: "#78909C",
                height: 1,
                width: "100%",
                offsetX: 0,
                offsetY: 0,
              },
            };

            this.vueChartshow = true;
            // if this variable is true only then it will show the bar chart

            let add = [];
            add.push(chartData);

            this.alertsData = add || [];

            let data = response.data.data[0];
            let parameter_group = data.parameter_group;
            this.parameter_group_obj = data.parameter_group;
            try {
              let devicedetail = this.ParameterGroupAssign(
                this.parameter_group_obj
              );
              this.DeviceParameterData = devicedetail[0];
              this.device_id = devicedetail[1];
            } catch (error) {
              console.log(error);
            }
            for (
              let param_grp_index = 0;
              param_grp_index < parameter_group.length;
              param_grp_index++
            ) {
              let id = -1;
              let minList = [];
              let maxList = [];
              let chartMinMaxObj = {};
              let dbc_params_map = new Map();
              let each_param_group_list =
                parameter_group[param_grp_index]["parameter_list"];
              let group_name = parameter_group[param_grp_index]["group"];
              let widget_type_name =
                parameter_group[param_grp_index]["widget_name"];

              console.log("checking param list group_name", group_name);
              if (!this.widgets_obj_map.has(widget_type_name)) {
                this.widgets_obj_map.set(widget_type_name, []);
              }
              const widgets_list = this.widgets_obj_map.get(widget_type_name);

              let chart_data_list = [];

              for (
                let param_grp_list_index = 0;
                param_grp_list_index < each_param_group_list.length;
                param_grp_list_index++
              ) {
                let param_actual_name =
                  each_param_group_list[param_grp_list_index]["actual_name"];
                let component_name =
                  each_param_group_list[param_grp_list_index]["name"];
                var maxValue = "";
                var minValue = "";
                id = each_param_group_list[param_grp_list_index]["id"];
                console.log(" param_actual_name is ", param_actual_name);
                console.log(" param_display_name is ", component_name);
                var timestamp = "";
                var originalValue = "";
                if (
                  each_param_group_list[param_grp_list_index]["db_parameters"]
                ) {
                  maxValue =
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                      .max_value;
                  minValue =
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                      .min_value;

                  maxList.push(maxValue);
                  minList.push(minValue);
                  dbc_params_map.set(
                    param_actual_name,
                    each_param_group_list[param_grp_list_index]["db_parameters"]
                  );
                }

                console.log("checking min and max", minValue, maxValue);
                var series = [0];
                let width = "100%";
                let maxwidth = "155px";
                let maxheight = "200px";

                if (widget_type_name == "Digital Gauge") {
                  let singleComponent = {
                    id,
                    originalValue,
                    component_name,
                    maxheight,
                    maxwidth,
                    series,
                    width,
                    timestamp,
                    minValue,
                    maxValue,
                  };
                  widgets_list.push(singleComponent);
                } else if (widget_type_name == "Line Chart") {
                  let singlValue = {
                    name: param_actual_name,
                    data: [],
                  };
                  chart_data_list.push(singlValue);
                }
              }
              chartMinMaxObj = {
                minvalue: Math.min(...minList),
                maxvalue: Math.max(...maxList),
              };

              if (widget_type_name == "Line Chart") {
                let finalData = this.finalizeDataNew(
                  chart_data_list,
                  group_name,
                  condemn_list,
                  chartMinMaxObj,
                  dbc_params_map
                );
                this.new_data_chart.push(finalData[2]);

                widgets_list.push(finalData[0]);
                this.alert_caution_map.set(group_name, finalData[1]);
              }
            }

            if (this.widgets_obj_map.has("Digital Gauge")) {
              this.guageSet = this.widgets_obj_map.get("Digital Gauge");
            }
            if (this.widgets_obj_map.has("Line Chart")) {
              this.apqData = this.widgets_obj_map.get("Line Chart");
            }
            this.showInsights = true;
            let machineinsights = response.data.data[0].machine_insights || [];
            // let machineinsights = [];

            console.log("checking machine insights", machineinsights);
            this.insightsData = [{ id: 1, insights: machineinsights }] || [];

            this.present = false;

            this.getData(
              this.machine_id_Selected,
              startDate,
              old_machine_id,
              endDate,
              show,
              grp_show,
              check
            );
            let timeStamp = this.timeConverter(this.end_date);
            let total_up_time_details =
              response.data.data[0].machine_up_time[0] || [];
            if (
              total_up_time_details.total_minutes != null &&
              total_up_time_details.avg_minutes != null
            ) {
              this.showGauge = true;

              let hours = Math.floor(total_up_time_details.total_minutes / 60);
              let minutes = total_up_time_details.total_minutes % 60;
              let curr_value = hours + " Hrs :" + minutes + " Mins";

              let machineUpTime =
                response.data.data[0].machine_up_time[0] || [];
              machineUpTime.timestamp = timeStamp;
              let start = this.start_date;
              if (this.end_date - this.start_date == 3600) {
                let d = new Date();
                start = d.setHours(0, 0, 0, 0) / 1000;
              }
              console.log("checki g start=>", start, this.end_date);
              let totalTime = (this.end_date - start) / 60;
              hours = Math.floor(totalTime / 60);
              minutes = totalTime % 60;
              let maxValue = hours + " Hrs :" + minutes.toFixed() + " Mins";
              let series = (
                (machineUpTime.total_minutes / totalTime) *
                100
              ).toFixed(2);
              machineUpTime.width = "100%";
              // let maxwidth = "510px";
              // let maxlength = "280px";
              this.guageData = {
                component_name: "Machine Up Time",
                // width: "100%",
                // maxwidth: maxwidth,
                // maxheight: maxlength,
                minValue: "00 Hrs: 00 Mins",
                isEnergy: "false",
                maxValue: maxValue,
                originalValue: curr_value,
                series: [series],
                percentage: series,
                id: 1,
                timestamp: this.timeConverter(this.end_date),
                // timestamp: 0,
              };
            } else if (
              total_up_time_details.total_minutes == null &&
              total_up_time_details.avg_minutes == null
            ) {
              this.showGauge = true;
              let machineUpTime = {};
              machineUpTime.timestamp = timeStamp;
              let curr_value = "0 Hrs :" + "0 Mins";
              machineUpTime.width = "100%";
              // let maxwidth = "460px";
              // let maxlength = "270px";
              this.guageData = {
                component_name: "Machine Up Time",
                // width: "100%",
                // maxwidth: maxwidth,
                // maxheight: maxlength,
                originalValue: curr_value,
                series: [0],
                id: 1,
                timestamp: this.timeConverter(
                  Math.max(...this.latestTimeStampsOfAllPlots)
                ),
                // timestamp: 0,
              };
              console.log(
                "checking Math.max(...this.latestTimeStampsOfAllPlots)=>",
                Math.max(...this.latestTimeStampsOfAllPlots)
              );
            }
            this.showLinechart = true;
          } catch (exception) {
            this.showLoader = false;

            this.apqData = [];
            console.log("error", exception);
          }
        })
        .catch((error) => {
          this.showLoader = false;

          if (error.response && error.response.status === 401) {
            sessionStorage.clear();
            router.push("/login");
          } else {
            alert("internal error");
            console.log("axios error", error.message);
          }
        });
    },
    sanitisedDataNew: (data, paramNames, category) => {
      let chartsGroupList = [];
      for (let i = 0; i < category.length; i++) {
        let singleMachineAPQ = {
          id: category[i].group,
          data: {},
        };
        let eachParameterList = category[i].parameter_list;
        for (let j = 0; j < eachParameterList.length; j++) {
          let eachParamNameDict = eachParameterList[j];
          let eachParamData = data[eachParamNameDict.id];
          if (eachParamData != undefined) {
            singleMachineAPQ.data[eachParamNameDict.name] = eachParamData;
          }
        }
        chartsGroupList.push(singleMachineAPQ);
      }
      return chartsGroupList;
    },
    finalizeDataNew: (
      seriesvalues,
      chartname,
      condemn_list,
      chartMinMaxObj,
      dbc_params_map
    ) => {
      console.log(
        "checking seriesvalues=>",
        seriesvalues,
        "chart names=>",
        chartname,
        "condemn_list =>",
        condemn_list,
        "dbc_params_map",
        dbc_params_map
      );
      console.log("chartMinMaxObj ist", chartMinMaxObj);
      let checkin = "";
      let lowAlertlist = [];
      let highAlertlist = [];
      let lowCautionlist = [];
      let highCautionlist = [];

      for (let i = 0; i < condemn_list.length; i++) {
        if (condemn_list[i].group_name == chartname) {
          checkin = condemn_list[i];
          if (checkin.high_alert != "null") {
            highAlertlist.push(checkin.high_alert);
          }
          if (checkin.low_alert != "null") {
            lowAlertlist.push(checkin.low_alert);
          }
          if (checkin.high_caution != "null") {
            highCautionlist.push(checkin.high_caution);
          }
          if (checkin.low_caution != "null") {
            lowCautionlist.push(checkin.low_caution);
          }
        }
      }
      let lowAlertValue = Math.min(...lowAlertlist);
      let highAlertValue = Math.max(...highAlertlist);
      let lowCautionValue = Math.min(...lowCautionlist);
      let highCautionValue = Math.max(...highCautionlist);

      console.log("lowCautionValue confirm", lowCautionValue);
      console.log("highAlertValue confirm", highAlertValue);
      let lowAlertChart = {
        name: "Alert",
        data: [lowAlertValue],
      };
      let lowCautionChart = {
        name: "Caution",
        data: [lowCautionValue],
      };
      let highAlertChart = {
        name: "Alert",
        data: [highAlertValue],
      };
      let highCautionChart = {
        name: "Caution",
        data: [highCautionValue],
      };
      let alertsValues = [];
      let cautionsValues = [];

      console.log("cehcking alerts", checkin.low_alert, checkin.high_alert);
      if (isFinite(lowAlertValue)) {
        alertsValues.push(lowAlertChart);
      }
      if (isFinite(highAlertValue)) {
        alertsValues.push(highAlertChart);
      }

      if (isFinite(lowCautionValue)) {
        cautionsValues.push(lowCautionChart);
      }
      if (isFinite(highCautionValue)) {
        cautionsValues.push(highCautionChart);
      }

      console.log("checking alerts array", highAlertChart, alertsValues);

      seriesvalues = seriesvalues.concat(alertsValues);
      seriesvalues = seriesvalues.concat(cautionsValues);
      console.log("checking seriveValuies", seriesvalues);
      let alert_caution_list = [alertsValues, cautionsValues];

      let timestampsLt = [];
      let seriesDataLineChart = [];

      let chartData = {
        id: chartname,
        chartTitle: chartname,
        series: seriesvalues,
      };

      console.log("this.getYAxisProperties(seriesvalues)", chartData);
      seriesDataLineChart = {
        chartTitle: chartname,
        seriesvalues: seriesvalues,
        timestampsLt: timestampsLt,
        dbc_params_map: dbc_params_map,
        lowCautionValue: lowCautionValue,
        lowAlertValue: lowAlertValue,
        highCautionValue: highCautionValue,
        highAlertValue: highAlertValue,
      };

      return [chartData, alert_caution_list, seriesDataLineChart];
    },
    intervalFetchData: function(
      machine_id,
      startDate,
      endDate,
      show,
      grp_show,
      check
    ) {
      console.log("Checking", check, typeof check);
      let old_machine_id = this.machine_id_Selected;
      this.checkBox = check;
      this.machine_id_Selected = machine_id;
      this.start_date = startDate;
      this.end_date = endDate;
      console.log("machine id", machine_id);
      console.log(
        "selected start date",
        startDate,
        "selected end date",
        startDate
      );
      this.searchNew(
        this.machine_id_Selected,
        old_machine_id,
        startDate,
        endDate,
        show,
        grp_show,
        check
      );
      this.assignparam(this.machine_id_Selected);
    },
  },
};
</script>

<style scoped>
@import "../assets/fonts/style.css";

.custom-card {
  height: 280px;
  width: 100%;
  margin-bottom: 10px;
}

@media screen and (min-width: 768px) {
  .custom-card {
    width: 50%; /* Two cards per row on screens larger than 768px (md) */
  }
}

@media screen and (min-width: 1024px) {
  .custom-card {
    width: 33.33%; /* Three cards per row on screens larger than 1024px (lg) */
  }
}
.v-list-item--link {
  border-bottom: 1px solid #e1e1e1;
}

.row.bg-white.mydrop {
  padding: 13px;
}
.my-datelist2.v-list {
  border-top: 1px solid #e1e1e1 !important;
}

.my-datelist2 .v-list-item__title {
  align-self: center;
  font-size: 0.91rem;
  color: #7e84a3;
}

.my-datelist2 .v-list-item {
  min-height: 34px;
}
.my-datelist2 .v-list-item:hover {
  background-color: #e9e9e9;
}

.my-datelist2 .v-list-item:hover .v-list-item__title {
  color: #0c479d;
}

.my-datelist2.v-sheet.v-list {
  padding: 0;
  /* margin-top: -35px; */
}

.btn-square2 {
  height: 48px !important;
  min-width: 48px !important;
  padding: 0 !important;
  border-radius: 5px !important;
}
.insights_ideal {
  color: #484848;
  font-size: 14px;
  font-weight: bold;
}
.insights_alert {
  color: #fe000c;
  font-size: 14px;
  font-weight: bold;
}
.insights_caution {
  color: #edfe00;
  font-size: 14px;
  font-weight: bold;
}
.insights_normal {
  color: #228517a4;
  font-size: 14px;
  font-weight: bold;
}
.insights_param {
  color: #484848;
  font-size: 16px;
  font-weight: bold;
}
.chartClass {
  border-style: solid;
  border-radius: 10px;
  border-color: #a7a7a7;
  border-width: thin;
  width: 460px;
  background-color: #fafafa;
  height: 270px;
  margin-right: 4px;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
